import { CreateExternalFlightBookingPaymentIntentState } from './createExternalFlightBookingPaymentIntent.types'

const initialState: CreateExternalFlightBookingPaymentIntentState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
